import React from 'react';
import UnauthorizedBanner from '../components/UnauthorizedBanner';

const UnauthorizedPage = () => {
  return <UnauthorizedBanner />;
};

export default UnauthorizedPage;
